// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"d9b63511e8a16c0206e3","303":"4d10f67ce349590bae5e","495":"68d19ce40c2353a6c847"}[chunkId] + ".js";
};